import ReactDOM from "react-dom/client";

import ErrorBoundary from "./config/middleware/ErrorBoundary";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

import storageKey from "./config/storageKey";
import genCode from "./config/util/genCode";

import App from "./App";

import "./assets/css/index.css";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

(window as any).deviceCustomId = window.localStorage.getItem(storageKey.DEVICE_CUSTOM_ID);
if (!(window as any).deviceCustomId) {
  const deviceId = genCode(12);
  (window as any).deviceCustomId = deviceId;
  window.localStorage.setItem(storageKey.DEVICE_CUSTOM_ID, deviceId);
}

const renderReactDom = () => {
  root.render(
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  );
};

if ("cordova" in window) {
  document.addEventListener(
    "deviceready",
    () => {
      renderReactDom();
    },
    false
  );
} else {
  renderReactDom();

  serviceWorkerRegistration.register();
}
